import { useProjectApi } from './gentian/useProjectApi';
import { useResultApi } from './gentian/useResultApi';
import { useHabmapApi } from './gentian/useHabmapApi';
import { useAccountApi } from './gentian/useAccountApi';
import { useProductApi } from './gentian/useProductApi';
import { useStripeApi } from './gentian/useStripeApi';
import { useCreditApi } from './gentian/useCreditApi';

const useGentian = () => ({
  ...useProjectApi(),
  ...useResultApi(),
  ...useHabmapApi(),
  ...useAccountApi(),
  ...useProductApi(),
  ...useStripeApi(),
  ...useCreditApi(),
});

export default useGentian;
